import { render, staticRenderFns } from "./LikesIndex.vue?vue&type=template&id=420ac360&lang=pug&"
import script from "./LikesIndex.vue?vue&type=script&lang=js&"
export * from "./LikesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports